import React, { useEffect, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Layout, Button, Dropdown, Input, Modal } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Dashboard, Events, Map, Organizers, Providers, Sponsors, Rewards } from "../pages";
import Sidebar from "./Sidebar";
// import { useContentContext } from "../providers/ContentContext"; // Not used
import { motion } from "framer-motion";
import { NotificationBell } from "../components";

const Main = ({ user, onLogout }) => {
  const [collapsed, setCollapsed] = useState(false);
  // const { openSuccessNotification } = useContentContext(); // Commented out unused variable
  const navigate = useNavigate();

  useEffect(() => {
    if (window.innerWidth < 426) {
      setCollapsed(true);
    }
  }, []);

  const handleLogout = () => {
    Modal.confirm({
      title: 'Confirmation de déconnexion',
      content: 'Êtes-vous sûr de vouloir vous déconnecter ?',
      onOk() {
        onLogout();
        navigate('/login');
      },
      okText: 'Déconnexion',
      cancelText: 'Annuler',
      okButtonProps: {
        className: 'bg-red-500 hover:bg-red-600 border-red-500 hover:border-red-600',
        danger: true,
      },
      cancelButtonProps: {
        className: 'hover:bg-neutral-50 border-neutral-200 text-neutral-600',
      },
      className: 'custom-modal-confirm',
      centered: true,
      maskClosable: true,
      width: 420,
      icon: null,
      closable: true,
    });
  };

  const getInitials = (name) => {
    if (!name) return 'NS';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const menuProps = {
    items: [
      {
        label: user?.name || "Admin",
        key: "profile-info",
        disabled: true,
      },
      {
        label: user?.email,
        key: "email-info",
        disabled: true,
      },
      {
        type: "divider",
      },
      {
        label: "Mon profil",
        key: "profile",
      },
      {
        label: "Paramètres",
        key: "settings",
      },
      {
        type: "divider",
      },
      {
        label: "Déconnexion",
        key: "logout",
        danger: true,
      },
    ],
    onClick: ({ key }) => {
      if (key === "logout") {
        handleLogout();
      }
    },
  };

  return (
    <Layout className="h-screen">
      <Sider
        className={`
          transition-all duration-300 border-r border-neutral-100 shadow-sm
          ${collapsed ? 'max-md:hidden' : 'visible'}
        `}
        theme="light"
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={280}
      >
        <Sidebar />
      </Sider>

      <Layout className="bg-neutral-50">
        <Header className="bg-white px-6 py-4 flex items-center justify-between border-b border-neutral-100 shadow-sm backdrop-blur-sm bg-white/80 sticky top-0 z-50">
          <div className="flex items-center space-x-6">
            <motion.div 
              whileTap={{ scale: 0.95 }}
              whileHover={{ scale: 1.05 }}
            >
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                className="text-neutral-600 hover:text-primary-600 hover:bg-primary-50 w-10 h-10 rounded-xl transition-colors duration-200"
              />
            </motion.div>
            <div className="max-w-xl hidden md:block">
              <Input
                prefix={<SearchOutlined className="text-neutral-400" />}
                placeholder="Rechercher..."
                className="rounded-xl border-neutral-200 hover:border-primary-300 focus:border-primary-500 h-10 transition-all duration-200"
              />
            </div>
          </div>

          <div className="flex items-center space-x-5">
            <NotificationBell count={5} />

            <Dropdown menu={menuProps} trigger={['click']} placement="bottomRight">
              <motion.div
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="flex items-center space-x-3 cursor-pointer p-2.5 rounded-xl hover:bg-neutral-50 transition-colors duration-200"
              >
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-100">
                  <span className="text-white font-medium text-sm">
                    {getInitials(user?.name || "Nadia Sabra")}
                  </span>
                </div>
                <div className="hidden md:block">
                  <p className="text-sm font-semibold text-neutral-800">
                    {user?.name || "Nadia Sabra"}
                  </p>
                  <p className="text-xs text-neutral-500 mt-0.5">
                    {user?.role || "Administratrice"}
                  </p>
                </div>
              </motion.div>
            </Dropdown>
          </div>
        </Header>

        <Content className="p-6 overflow-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-2xl shadow-md min-h-full p-6 border border-neutral-100"
          >
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/map" element={<Map />} />
              <Route path="/events" element={<Events />} />
              <Route path="/organizers" element={<Organizers />} />
              <Route path="/providers" element={<Providers />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/rewards" element={<Rewards />} />
            </Routes>
          </motion.div>
        </Content>

        <Footer className="text-center bg-white border-t border-neutral-100 py-4 shadow-sm">
          <p className="text-neutral-500 text-sm">
            © 2025 Aventure It Solution. Tous droits réservés.
          </p>
        </Footer>
      </Layout>
    </Layout>
  );
};

export default Main;
